import React, { Component } from 'react';
import PubSub from 'pubsub-js';

// Componet's style
import '../css/HeaderMobileMenu.css';


class HeaderMobileMenu extends Component {
    constructor() {
        super();

        this.state = {
            visible: false,
            className: "",
            lang: "pt"
        };

        this.locationTexts = {
            "inicio": { "pt": "Início", "es": "Home", "en": "Home" },
            "institucional": { "pt": "Institucional", "es": "Institucional", "en": "Institutional" },
            "direitos": {
                "pt": "Todos direitos reservados",
                "es": "Todos los derechos reservados",
                "en": "All rights reserved"
            },
            "pt": { "pt": "Português", "es": "Portugués", "en": "Portuguese" },
            "es": { "pt": "Espanhol", "es": "Español", "en": "Spanish" },
            "en": { "pt": "Inglês", "es": "Inglés", "en": "English" }
        };
    }

    toggle() {
        if (this.state.visible) {
            this.setState({
                visible: false,
                className: ""
            });
        } else {
            this.setState({
                visible: true,
                className: "visible"
            });
        }

    }

    componentWillMount() {
        PubSub.subscribe('language.change', (msg, lang) => this.setState({ lang }));
    }

    render() {
        let texts = this.locationTexts;

        return (
            <div id="mobile-menu" className={this.state.className} >
                <header id="mobile-menu-header">
                    <span
                        onClick={() => this.toggle()}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </span>
                </header>

                <nav id="mobile-menu-nav">
                    <a href="/" className="active">{texts["inicio"][this.state.lang]}</a>
                    <a href="https://www.escolhatecnologia.com.br">{texts["institucional"][this.state.lang]}</a>
                </nav>
                <div id="mobile-menu-footer">
                    <nav id="mobile-menu-footer-socialIcons">
                        <a href="https://www.facebook.com/escolhatecnologia"><i className="fab fa-facebook-square"></i></a>
                        <a href="https://www.instagram.com/escolhatecnologia/"><i className="fab fa-instagram"></i></a>
                        <a href="https://twitter.com/escolhatec"><i className="fab fa-twitter"></i></a>
                        <a href="https://www.youtube.com/channel/UCr632Bp9WjTKhkhzCioT1Pw"><i className="fab fa-youtube"></i></a>
                    </nav>

                    <div id="mobile-menu-footer-bottom-content">
                        <nav id="mobile-menu-footer-language-nav">
                            <span onClick={() => PubSub.publish("language.change", "pt")}>{texts["pt"][this.state.lang]}</span>&nbsp;&nbsp;
                            <span onClick={() => PubSub.publish("language.change", "en")}>{texts["en"][this.state.lang]}</span>&nbsp;&nbsp;
                            <span onClick={() => PubSub.publish("language.change", "es")}>{texts["es"][this.state.lang]}</span>
                        </nav>
                        <div id="mobile-menu-footer-copyright">
                            2018 {texts["direitos"][this.state.lang]} | Escolha Tecnologia
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default HeaderMobileMenu;



// WEBPACK FOOTER //
// ./src/componentes/HeaderMobileMenu.js